import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { setWriteOffAct } from '../../../../store/writeOffSlice'
import ErrorMessage from '../../../UI/messages/ErrorMessage'
import AddTabs from '../../../addTabs/AddTabs'
import { getWriteOffActAPI } from '../../../../api/writeOff/writeOffActAPI'
import WriteOffActAbout from './about/WriteOffActAbout'
import WriteOffActUser from './user/WriteOffActUser'
import WriteOffActItems from './items/WriteOffActItems'
import WriteOffActFiles from './files/WriteOffActFiles'

const WriteOffActView = ({ writeOffActId }) => {

	const writeOffAct = useSelector(state => state.writeOff.writeOffAct)
    const dispatch = useDispatch()
    // const [supplyOrder, setSupplyOrder] = useState('')

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        getSupplyOrder()
    }, [writeOffActId])

    const getSupplyOrder = () => {
        setLoading(true)

        getWriteOffActAPI({ writeOffActId }).then(data => {
            // setSupplyOrder(data)
            dispatch(setWriteOffAct(data))
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }
  
  return (
    <div className='supplyOrderView'>
        <ErrorMessage error={error} />
        {
            !error ?
                <>
                    <div className='supplyOrderView__left'>
                        <div className='supplyOrderView__top'>
                            <WriteOffActAbout 
                                writeOffAct={writeOffAct}
                            />
                            <WriteOffActUser 
                                writeOffActId={writeOffActId}
                            />
                        </div>
						<div>
                            <WriteOffActFiles
                                writeOffActId={writeOffActId}
                            />
                        </div>
                        <WriteOffActItems 
                            writeOffActId={writeOffActId}
                        />
                    </div>
                    <div className='supplyOrderView__right'>
                        <AddTabs
                            comments={writeOffAct.comments}
                            changes={writeOffAct.changes}
                            writeOffActId={writeOffActId}
                        />
                    </div>
                </>
            : ''
        }
    </div>
  )
}

export default WriteOffActView